import { render } from "./Mypage.vue?vue&type=template&id=2c3471f5&scoped=true"
import script from "./Mypage.vue?vue&type=script&lang=js"
export * from "./Mypage.vue?vue&type=script&lang=js"

import "./Mypage.vue?vue&type=style&index=0&id=2c3471f5&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3471f5"]])

export default __exports__